<template>
  <ElDialog
    :visible="value"
    :title="$t('APP.RELEASES.DISABLE_AUTO_PUBLISH_TITLE')"
    width="440px"
    center
    class="disable-auto-publish-modal"
    @close="handleClose"
  >
    <p class="disable-auto-publish-modal__desc">
      {{ $t('APP.RELEASES.DISABLE_AUTO_PUBLISH_DESC') }}
    </p>
    <div slot="footer" class="disable-auto-publish-modal__buttons">
      <ElButton type="text" size="small" @click="handleClose">
        {{ $t('CANCEL') }}
      </ElButton>
      <ElButton type="primary" size="small" @click="handleConfirm">
        {{ $t('CONFIRM') }}
      </ElButton>
    </div>
  </ElDialog>
</template>

<script>
export default {
  name: 'DisableAutoPublishModal',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleClose() {
      this.$emit('input', false);
      this.$emit('cancel');
    },
    handleConfirm() {
      this.$emit('input', false);
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="scss">
.disable-auto-publish-modal.el-dialog__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.disable-auto-publish-modal {
  .el-dialog {
    width: 440px !important;
    max-width: 440px;
    margin: 0 !important;
  }

  .el-dialog__header {
    text-align: right;
  }

  .el-dialog__footer {
    text-align: left;
  }

  &__desc {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.66);
    line-height: 1.8;
    text-align: right;

    @include ltr() {
      text-align: left;
    }
  }

  &__buttons {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    align-items: center;

    .el-button--primary {
      background-color: $nephritis;
      border-color: $nephritis;

      &:hover,
      &:focus {
        background-color: darken($nephritis, 5%);
        border-color: darken($nephritis, 5%);
      }
    }

    .el-button--text {
      color: $nephritis;
    }
  }
}
</style>
